import { Form } from 'antd'
import { Container } from '../../components/Container/Container'
import { ADD_GPO_DETAILS_BREADCRUMBS, initialState } from './constants'
import { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { getGpoDetailsList } from '../../features/MyCommunity/Gpo/api'
import { GPOItem } from '../../features/MyCommunity/Gpo/types'
import { AddGpoForm } from './AddGpoForm'

export const AddGpoDetails = () => {
  const { id } = useParams()
  const [form] = Form.useForm()

  const isCreate = id === 'create'

  const [details, setDetails] = useState<GPOItem>(initialState)

  const getPredefinedData = useCallback(async () => {
    if (id === 'create') return
    const res = await getGpoDetailsList(id)
    setDetails(res?.data)
    form.setFieldsValue({
      ...res.data,
      phone_number: res.data.phone_number?.replace('+1', '')
    })
  }, [form, id])

  useEffect(() => {
    if (id) getPredefinedData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  return (
    <Container
      title={isCreate ? 'Create GPO' : details.name}
      breadcrumbs={ADD_GPO_DETAILS_BREADCRUMBS(details?.name)}
      className="gpo-details-container"
    >
      <AddGpoForm
        form={form}
        details={details}
        isEdit={!isCreate}
        isGeneral={false}
      />
    </Container>
  )
}
